import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import { DialogProvider } from '../../contexts/DialogContext';
import { Topbar } from './components/Topbar';
import { Overview } from './Overview';
import { WorkOrder } from './WorkOrder';
import { useOfflineDashboard } from 'src/contexts/OfflineDashboardContext';

export function OfflineDashboard() {
    const { internetConnected } = useOfflineDashboard();
    return (
        <>
            <Helmet>
                <title>Offline Dashboard</title>
            </Helmet>
            <DialogProvider>
                <Topbar isOnline={internetConnected} />
                <Container maxWidth="md">
                    <Box my="64px">
                        <Switch>
                            <Route exact path="/offline/overview" component={Overview} />
                            <Route exact path="/offline/work-order/:workOrderId" component={WorkOrder} />
                            <Redirect from="/*" to="/offline/overview" exact />
                        </Switch>
                    </Box>
                </Container>
            </DialogProvider>
        </>
    );
}
